import UserService from '@/services/admin/user.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async searchUsers({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.searchUsers(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

    // user add/edit data
    async getUserEditData({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.getUserEditData(id);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

    async signUserUp ({commit, getters}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.signUserUp(payload);

            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async updateUser ({commit, getters}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.updateUser(payload);

            return response
        } catch (e) {
            // console.log(e.response.data)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    // updateUser ({commit, getters}, payload) {
    //     commit('setLoading', true)
    //     commit('clearError')
    //     let url = `${getters.baseApiUrl}/api/Account/UpdateUser`
    //     // if (payload.roles.length === 0) {
    //     //     url = `${getters.baseApiUrl}/api/UserEdit/AddUpdateUser`
    //     // }
    //     const authHeader = getters.getAuthHeader

    //     return axios.post(url, payload, authHeader)
    //         .then(response => {
    //             // console.log(response)
    //             commit('setLoading', false)
    //             return true
    //         })
    //         .catch(
    //             error => {
    //                 commit('setLoading', false)
    //                 commit('setError', {message: error.response.data.ExceptionMessage})
    //                 // console.log(error.response.data.error_description)
    //             }
    //         )
    // },
    async activeDeactiveUser({commit}, id) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.activeDeactiveUser(id);

            return response
        } catch (e) {
            // console.log(e)
            return e.response.data
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async resetPassword({commit}, email) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.resetPassword(email);

            return response
        } catch (e) {
            // console.log(e)
            return e.response.data
        } finally {
            commit('setLoading', false, { root: true })

        }
    },

    // ------------------roles related
    async getAllRoles ({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.getAllRoles();
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },
    // ------------------end roles related

    // -------------------HMTerrAssign data search
    // async searchRepsForWebQuote ({commit}, zip) {
    //     try {
    //         commit('setLoading', true, { root: true })
    //         commit('clearError', null, { root: true })
    //         const response = await UserService.searchRepsForWebQuote(zip);
    //         commit('setLoading', false, { root: true })


    //         return response
    //     } catch (e) {
    //         // console.log(e)
    //         return e
    //     } finally {
    //         commit('setLoading', false, { root: true })

    //     }

    // },

    // -------------------end HMTerrAssign data search
 
    // -------------------initial user, region, territory population
    async populateInitData ({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.populateInitData(payload);
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    async importTazData ({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const response = await UserService.importTazData();
            commit('setLoading', false, { root: true })


            return response
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }

    },

    // -------------------end initial user, region, territory population

}

const mutations = {
}

export const adminUser = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}